/**
 * Pixelposition eines Zeichens in einem `<textarea>` — für die Cursor der
 * anderen (#305). Ein Textfeld verrät das nicht; gemessen wird an einem
 * unsichtbaren Spiegel mit denselben Maßen und derselben Schrift (das
 * bekannte Verfahren hinter „textarea-caret-position").
 */
const GESPIEGELT = [
  "direction", "boxSizing", "width", "height", "overflowX", "overflowY",
  "borderTopWidth", "borderRightWidth", "borderBottomWidth", "borderLeftWidth", "borderStyle",
  "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
  "fontStyle", "fontVariant", "fontWeight", "fontStretch", "fontSize", "fontSizeAdjust", "lineHeight", "fontFamily",
  "textAlign", "textTransform", "textIndent", "textDecoration", "letterSpacing", "wordSpacing", "tabSize",
] as const;

export function caretKoordinaten(
  feld: HTMLTextAreaElement,
  index: number,
  /** Der Text, der gerade gezeichnet wird — beim Rendern steht im DOM noch der vorige. */
  wert: string = feld.value,
): { top: number; left: number; hoehe: number } {
  const spiegel = document.createElement("div");
  const stil = getComputedStyle(feld);
  const s = spiegel.style as unknown as Record<string, string>;
  for (const p of GESPIEGELT) s[p] = (stil as unknown as Record<string, string>)[p] ?? "";
  s.whiteSpace = "pre-wrap";
  s.overflowWrap = "break-word";
  s.position = "absolute";
  s.visibility = "hidden";
  s.top = "0";
  s.left = "-9999px";
  s.overflow = "hidden";
  spiegel.textContent = wert.slice(0, index);
  const marke = document.createElement("span");
  marke.textContent = wert.slice(index) || ".";
  spiegel.appendChild(marke);
  document.body.appendChild(spiegel);
  const zeile = parseFloat(stil.lineHeight);
  const ergebnis = {
    top: marke.offsetTop + (parseFloat(stil.borderTopWidth) || 0) - feld.scrollTop,
    left: marke.offsetLeft + (parseFloat(stil.borderLeftWidth) || 0) - feld.scrollLeft,
    hoehe: Number.isFinite(zeile) ? zeile : (parseFloat(stil.fontSize) || 14) * 1.4,
  };
  document.body.removeChild(spiegel);
  return ergebnis;
}

const FARBEN = ["#1c7ed6", "#e8590c", "#2f9e44", "#ae3ec9", "#c2255c", "#0c8599", "#5f3dc4", "#e67700"];

/** Feste Farbe je Person, damit dieselbe Person überall gleich aussieht. */
export function farbeFuer(employeeId: string): string {
  let h = 0;
  for (const z of employeeId) h = (h * 31 + z.charCodeAt(0)) >>> 0;
  return FARBEN[h % FARBEN.length]!;
}
